<template>
  <div class="col col-lg-3">
    <label for="codigoAgenteField">
      Código do Agente
      <span class="recent-updated-label" v-if="recentUpdatedField">
        <tooltip-informacao-alterada />
      </span>
      <div class="input-group">
        <input
          type="text"
          maxlength="255"
          class="form-control"
          id="codigoAgenteField"
          ref="codigoAgenteField"
          @input="replaceNotNumericCharacters"
          v-model.trim="$v.model.content.$model"
          :class="{
            'is-invalid': $v.model.content.$error,
            'recent-updated': recentUpdatedField,
          }"
          :disabled="disabled"
        />
      </div>
      <div class="form-text">Único para empresa.</div>
    </label>
  </div>
</template>

<script>
import TooltipInformacaoAlterada from "@/components/forms/TooltipInformacaoAlterada.vue";
import { numberWOSpecialCaracter } from "@/filters/assertions";
import AwesomeMask from "awesome-mask";
export default {
  props: {
    modelProp: Object,
    disabled: Boolean,
    recentUpdatedField: Boolean,
  },
  data() {
    return {
      model: {
        name: "codigoAgente",
        content: "",
      },
    };
  },
  methods: {
    focusField() {
      this.$refs.codigoAgenteField.classList.add("is-invalid");
      this.$refs.codigoAgenteField.focus();
    },
    isInvalid() {
      this.$refs.codigoAgenteField.classList.remove("is-invalid");
      if (!this.$parent.editingComponent) return false;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.mxToggleErrorMessageAlert("Campo Código do Agente inválido");
        return true;
      }
      return false;
    },
    replaceNotNumericCharacters() {
      const newValueCargaCcee = this.model.content.replace(/[^\d]/gim, "");
      this.model.content = newValueCargaCcee;
    },
  },
  directives: {
    mask: AwesomeMask,
  },
  watch: {
    modelProp: {
      deep: true,
      handler() {
        this.model.content = this.modelProp[this.model.name];
      },
    },
    "model.content": {
      deep: true,
      handler() {
        this.modelProp[this.model.name] = this.model.content;
      },
    },
    disabled() {
      if (this.disabled) this.model.content = null;
    },
  },
  validations: {
    model: {
      content: {
        numberWOSpecialCaracter,
      },
    },
  },
  components: {
    TooltipInformacaoAlterada,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/style.scss";
label {
  width: 100% !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
